import { loading } from '@/utils/feedback'
import { isMyApp } from '@/utils/bridge'
import { toAppChat } from '@/api/app'

let loadPromise

export function load() {
  if (loadPromise) return loadPromise
  const _53code = document.createElement("script")
  _53code.src = "https://tb.53kf.com/code/code/fe715350fe2dcab90c2780cd6c2842e18/4"
  const s = document.getElementsByTagName("script")[0]
  s.parentNode.insertBefore(_53code, s)
  loading.show()
  loadPromise = new Promise((resolve, reject) => {
    _53code.onload = () => {
      setTimeout(() => {
        loading.hide()
        resolve()
      }, 300)
    }
    _53code.onerror = (e) => {
      loadPromise = null
      loading.hide()
      reject(e)
    }
  })
  return loadPromise
}

async function openWebKf() {
  await load()
  const api = window.$53.createApi()
  api.push('cmd', 'mtalk')
  api.query()
}

export function open() {
  return !isMyApp ? openWebKf() : toAppChat()
}